import { render, staticRenderFns } from "./KpiDirections.vue?vue&type=template&id=451c5592&"
import script from "./KpiDirections.vue?vue&type=script&lang=js&"
export * from "./KpiDirections.vue?vue&type=script&lang=js&"
import style0 from "./KpiDirections.vue?vue&type=style&index=0&id=451c5592&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports